export default __webpack_public_path__ + "static/media/admisstion.2d03b6c6.png";